<template>
  <div :class="rowClasses" :id="`row-${row.id}`" :style="rowStyles">
    <div :class="['container']" :style="containerStyles">
      <LayoutColumn
        :index="i.toString()"
        ref="columns"
        @change="onColumnContentChange(i)"
        :key="`${keyBase}-col-${i}`"
        :blocks="column.blocks"
        v-for="(column, i) in localRow.columns"
        :class="`column-${column.key}`"
      ></LayoutColumn>
    </div>
  </div>
</template>
<script>
import Utilities from "../../lib/Utilities";
import LayoutColumn from "./LayoutColumn.vue";
import ColumnMenu from "./ColumnMenu.vue";

export default {
  props: {
    id: { type: String, default: "" },
    translationContext: { type: String, default: "" },
    row: {
      type: Object,
      default: () => {
        {
        }
      }
    },
    //columns: {type: Array, default: () => []},
    columnClass: { type: String, default: "" }
    // showOverlay: {type: Boolean, default: false}
  },
  provide() {
    return {
      translationContext: this.translationContext
    };
  },
  computed: {
    keyBase() {
      return this.$vnode.key;
    },
    rowStyles() {
      let style = {};
      style.backgroundColor = this.row.backgroundColor || "transparent";
      if (this.row.backgroundImage) {
        style.backgroundImage = `url(${this.row.backgroundImage})`;
      }
      return style;
    },
    containerStyles() {
      let style = {};
      if (this.row.maxWidth) {
        style.maxWidth = `${this.row.maxWidth}%`;
        style.margin = "auto";
      }
      return style;
    },
    rowClasses() {
      let classes = ["layout-row"];
      return classes;
    }
  },
  data() {
    return {
      localRow: {},
      addPopoverKey: "",
      addPopoverSelector: "",
      addPopover: null,
      removePopoverKey: "",
      removePopoverSelector: "",
      removePopover: null,
      resizeEnabled: false,
      showOverlay: false,
      tippyReady: false
    };
  },
  components: {
    LayoutColumn
  },
  created() {
    this.localRow = JSON.parse(JSON.stringify(this.row));
    this.localColumns = this.localRow.columns;
    this.$watch("localRow", this.onChange, { deep: true });
  }
};
</script>
<style lang="scss">
.tippy-content .layout-row-menu {
  padding: 10px;
  li {
    padding: 5px;
    border: 1px solid #fff;
    a {
      cursor: pointer;
      color: white;
      text-decoration: none !important;
      &:visited {
        color: white;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import "./scss/layout";
.container {
  position: relative;
}
.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background-color: rgba(240, 210, 10, 0.3);
  transition: 0.3s all;
  opacity: 0;
  &.show {
    opacity: 1;
  }
}
/deep/ .layout-column-menu .column-options {
  width: 50%;
  margin: auto;
}
.layout-resizer,
.layout-column-menu {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 100;
}

.row-actions {
  text-align: center;
  background-color: #efefef;
  padding: 3px 0;
  &:hover {
    a.menu-button {
      opacity: 1;
      span.label {
        display: inline;
      }
    }
  }
}

a.menu-button {
  line-height: 17px;
  opacity: 0.3;
  min-width: unset;
  padding: 5px;
  font-size: 17px;
  cursor: pointer;
  height: 17px;
  span.label {
    display: none;
    font-size: 10px;
    vertical-align: 1px;
  }
}
</style>
